// OP1WebAW: look designed in Plasmic, window behaviour from
// appWindowBehavior.jsx (drag from header slot, resize, focus, close,
// maximize, starting/maximized size props).
// This file is owned by us: `plasmic sync` never overwrites it.
import { PlasmicOp1WebAw } from "./plasmic/one_platform/PlasmicOp1WebAw";
import { createAppWindow } from "./appWindowBehavior";

const Op1WebAw = createAppWindow(PlasmicOp1WebAw, "Op1WebAw");

export default Op1WebAw;
